import React from 'react';

export const BoxOutlined = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_480_50768"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="17"
    >
      <rect y="0.5" width="16" height="16" fill={color || '#D9D9D9'} />
    </mask>
    <g mask="url(#mask0_480_50768)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.23945 3.81221V6.43974H5.99792V3.81221H3.23945ZM2.93945 2.51221C2.38717 2.51221 1.93945 2.95992 1.93945 3.51221V6.73974C1.93945 7.29202 2.38717 7.73974 2.93945 7.73974H6.29792C6.85021 7.73974 7.29792 7.29202 7.29792 6.73974V3.51221C7.29792 2.95992 6.85021 2.51221 6.29792 2.51221H2.93945Z"
        fill="#7D7A9A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.89375 3.81221V6.43974H12.6522V3.81221H9.89375ZM9.59375 2.51221C9.04147 2.51221 8.59375 2.95992 8.59375 3.51221V6.73974C8.59375 7.29202 9.04146 7.73974 9.59375 7.73974H12.9522C13.5045 7.73974 13.9522 7.29202 13.9522 6.73974V3.51221C13.9522 2.95992 13.5045 2.51221 12.9522 2.51221H9.59375Z"
        fill="#7D7A9A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.23945 10.5603V13.1878H5.99792V10.5603H3.23945ZM2.93945 9.26025C2.38717 9.26025 1.93945 9.70797 1.93945 10.2603V13.4878C1.93945 14.0401 2.38717 14.4878 2.93945 14.4878H6.29792C6.85021 14.4878 7.29792 14.0401 7.29792 13.4878V10.2603C7.29792 9.70797 6.85021 9.26025 6.29792 9.26025H2.93945Z"
        fill="#7D7A9A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.89375 10.5603V13.1878H12.6522V10.5603H9.89375ZM9.59375 9.26025C9.04147 9.26025 8.59375 9.70797 8.59375 10.2603V13.4878C8.59375 14.0401 9.04146 14.4878 9.59375 14.4878H12.9522C13.5045 14.4878 13.9522 14.0401 13.9522 13.4878V10.2603C13.9522 9.70797 13.5045 9.26025 12.9522 9.26025H9.59375Z"
        fill="#7D7A9A"
      />
    </g>
  </svg>
);
